import React from 'react';
import styles from './MonitoringCenterList.module.scss';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import Loading from '../../../../Components/Loading';
import InfiniteScroll from 'react-infinite-scroll-component';
import useSocket from '../../../Base/Hooks/useSocket';
import { Socket } from '../../../Base/Enums/Socket.enum';
import OverlayLoading from '../../../../Components/OverlayLoading';
import MonitoringCenterListTable, {
	MonitoringCenterCase,
	MonitoringCenterTable,
} from '../MonitoringCenterListTable/MonitoringCenterListTable';
import { Case } from '../../../../graphql/graphql';
import { DataTableColumn } from '../../../Base/Components/DataTable/DataTable';
import useScrollGuard from '../../../Base/Hooks/useScrollGuard';

interface Props {
	data: Case[];
	onLoadMore: () => void;
	onRefresh: () => void;
	isLoading: boolean;
	hasMoreData: boolean;
	isStatic?: boolean;
	columns: DataTableColumn<MonitoringCenterCase, MonitoringCenterTable>[];
}

const WRAPPER_ID = 'monitoringCenterListWrapper';

const MonitoringCenterList: React.FC<Props> = ({
	data,
	onLoadMore,
	onRefresh,
	hasMoreData,
	isStatic = false,
	isLoading,
	columns,
}) => {
	useSocket(Socket.CASE_CREATED, onRefresh);

	const { scrollContainerRef } = useScrollGuard<Case>({
		data,
		isLoading,
		onLoadMore,
		hasMoreData,
	});

	if (isStatic) {
		return (
			<>
				{isLoading && <OverlayLoading />}
				<MonitoringCenterListTable
					data={data}
					columns={columns}
					table={{ refresh: onRefresh }}
				/>
			</>
		);
	}

	return (
		<div className={styles.wrapper}>
			{isLoading && <OverlayLoading />}
			<ScrollContainer wrapperId={WRAPPER_ID} ref={scrollContainerRef}>
				<InfiniteScroll
					dataLength={data.length}
					refreshFunction={onRefresh}
					next={onLoadMore}
					hasMore={hasMoreData}
					loader={<Loading />}
					scrollableTarget={WRAPPER_ID}>
					<MonitoringCenterListTable
						data={data}
						columns={columns}
						table={{ refresh: onRefresh }}
					/>
				</InfiniteScroll>
			</ScrollContainer>
		</div>
	);
};

export default MonitoringCenterList;
